import ajax from '@/helpers/ajax';
import config from '@/config';

export const myCars = {
  namespaced: true,
  state: {
    cars: [],
  },
  getters: {
    getMyCars(state) {
      return state.cars;
    },
  },
  actions: {
    fetchMyCars({ rootState, dispatch }) {
      const params = { brand: rootState.brand.brandID };

      return new Promise((resolve, reject) => {
        ajax.get(config.apiEndpoints.userCars, { params })
          .then((res) => {
            if (res.status === 200) {
              dispatch('setMyCars', res.data);
              resolve(res);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setMyCars({ commit }, cars) {
      commit('setMyCars', cars);
    },
    addNewCar({ dispatch }, data) {
      const { licensePlate, vin, id } = data;
      const newCar = {
        licensePlate, vin, id, visits: [],
      };

      return ajax.put(config.apiEndpoints.updateUserCars, { ...newCar })
        .then((res) => {
          if (res.status === 200) {
            dispatch('addCar', {
              ...res.data,
              visits: [],
            });
          }
        })
        .catch((error) => {
          return error.response.data;
        });
    },
    updateMyCar({ dispatch, state }, data) {
      const { licensePlate, vin, id } = data;
      const formattedData = { licensePlate, vin };
      ajax.post(`${config.apiEndpoints.updateUserCars}:${id}`, formattedData)
        .then((res) => {
          if (res.status === 200) {
            const editedCar = state.cars.find(carModel => carModel.id === id);
            dispatch('editCar', { ...editedCar, licensePlate, vin });
          }
        });
    },
    editCar({ commit }, updatedCars) {
      commit('editCar', updatedCars);
    },
    addCar({ commit }, car) {
      commit('addCar', car);
    },
    removeCar({ commit }, carID) {
      commit('removeCar', carID);
    },
  },
  mutations: {
    setMyCars(state, cars) {
      state.cars = cars;
    },
    addCar(state, car) {
      state.cars = [
        ...state.cars,
        car,
      ];
    },
    editCar(state, car) {
      state.cars = state.cars.map((carModel) => {
        if (carModel.id === car.id) {
          return car;
        }
        return carModel;
      });
    },
    removeCar(state, carID) {
      state.cars = state.cars.filter(car => car.id !== carID);
    },
  },
};
